export class MarinaMessage {
  id?: number;
  idMarina: number;
  messageType: string;
  messageText: string;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

